import React, { useState } from "react";
import { TextField, FormControl, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { facebookTextFieldStyles } from "../../../styles/textFieldStyles";

const TextInput = ({
  id,
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  helperText,
  type = "text",
  options = {},
}) => {
  // Local state to toggle password string masking dynamically
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // Check if this specific instance is meant to be a password field
  const isPasswordField = type === "password" || name === "password";

  // Determine the real, active HTML input type attribute
  const inputType = isPasswordField ? (showPassword ? "text" : "password") : type;

  return (
    <FormControl
      fullWidth
      required={required}
      sx={{
        mb: { xs: 1.5, sm: 2, md: 2.5 },
      }}
    >
      <TextField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        helperText={helperText}
        type={inputType} // Dynamically swaps between "text" and "password"
        fullWidth
        InputProps={{
          notched: false,
          // Render the end adornment icon block conditionally
          endAdornment: isPasswordField && value ? (
            <InputAdornment position="end" sx={{ mt: "12px", mr: "4px" }}>
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
                style={{ color: "#606770" }}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ) : null,
          ...options.InputProps // Merges any extra InputProps passed from parent fields safely
        }}
        sx={facebookTextFieldStyles}
        {...options}
      />
    </FormControl>
  );
};

export default TextInput;